'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';

import { fetchDocumentsById } from '../../../../../utils/Content';
import allMealKitBrands from '../../../../../tables/meal-kit-brands';

import ImgResized from '../../../../Widgets/ImgResized.react';
import Popup from '../../../../Widgets/Popup.react';

import './ComboCard.scss';
import './CardAbstract.scss';

export default class ComboCard extends Component {

    static contextTypes = {
        user: PropTypes.object,

        showComboDetails: PropTypes.func,
        onSelectCombo: PropTypes.func,
        addSwapContext: PropTypes.object,
        showUpgradeForm: PropTypes.func,
    }

    onSelectCombo = () => {
        const { combo } = this.props;
        const { onSelectCombo, addSwapContext, user, showUpgradeForm } = this.context;
        const { params: { sort_by, sort_order }, searchRanking} = this.props;

        // Check if combo is locked and user doesn't have meal_planner capability
        const { capabilities = {} } = user || {};
        if (combo.protection !== 'public' && !capabilities.meal_planner) {
            showUpgradeForm({ feature: 'meal_planner' });
            return;
        }

        fetchDocumentsById([combo.main_dish, combo.side_dish]).then(documents => {
            let mainDish, sideDish;

            documents.forEach(doc => {
                if (combo.main_dish === doc.uuid) {
                    mainDish = doc;
                }

                if (combo.side_dish === doc.uuid) {
                    sideDish = doc;
                }
            });

            onSelectCombo(combo, mainDish, sideDish, addSwapContext.participants, undefined, undefined, {searchRanking, sortBy: sort_by, sortOrder: sort_order, source: 'Smart Choices'});
        });
    }

    render = () => {
        const { combo, efficiencyDelta } = this.props;
        const { user, showComboDetails } = this.context;
        const { capabilities } = user;

        return (
            <div className="card-abstract combo-card">
                {typeof efficiencyDelta === 'number' && efficiencyDelta > 0 ? (
                    <div className="minimizes-waste-label">
                        MINIMIZES WASTE
                        <Popup className="el-popup-dark"
                            positionClassName="el-popup-right-bottom"
                            button={<i className="icon-info"/>}
                            buttonTitle="">
                            <p>This recipe uses ingredients that work well with your other planned meals, reducing your overall grocery costs and food waste.</p>
                        </Popup>
                    </div>
                ) : null}

                {/*typeof efficiencyDelta === 'number' && efficiencyDelta < 0 ? (
                    <div className="increases-waste-label">
                        INCREASES WASTE {(efficiencyDelta * -100).toFixed(2)}%
                    </div>
                ) : null*/}

                <ImgResized className="card-image" src={combo.main_image} width={470} height={356} onClick={() => showComboDetails(combo)} />

                {(combo.tags || []).includes('Grab & Go') ?
                    <div className="card-overlay" onClick={() => showComboDetails(combo)} >
                        Store Bought
                    </div>
                : null}

                <div className="card-info">
                    {combo.main_brand_uuid && allMealKitBrands[combo.main_brand_uuid] ?
                        <img height="21" className="provider-logo" src={allMealKitBrands[combo.main_brand_uuid].logo} />
                    : null}

                    <h3><em>{combo.main_title}</em> + <em>{combo.side_title}</em></h3>

                    <button onClick={this.onSelectCombo}>
                        select meal
                        {(combo.protection !== 'public' && !capabilities.meal_planner) ? <i className="icon-lock" /> : null}
                    </button>
                </div>
            </div>
        );
    }
}
